import { render } from "./WorkMainPage.vue?vue&type=template&id=09086c24&scoped=true"
import script from "./WorkMainPage.vue?vue&type=script&lang=js"
export * from "./WorkMainPage.vue?vue&type=script&lang=js"

import "./WorkMainPage.vue?vue&type=style&index=0&id=09086c24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09086c24"]])

export default __exports__